var exports = {
  "t": "MonaFooter__AUd-X5",
};

module.exports = exports;
